(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/grid/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/tur/grid/assets/javascripts/prescript.js');

svs.tur = svs.tur || {};
svs.tur.grid = svs.tur.grid || {};


 })(window);